export default function SortByDate(data) {
  const entries = Object.entries(data);
  entries.sort((a, b) => new Date(a[0]) - new Date(b[0]));

  return Object.fromEntries(entries);
}